import request from '@/utils/request'

export default {
  // 上传图片
  uploadImgForOss(data) {
    return request({
      url: `${process.env.VUE_APP_UPLOAD_PUBLIC_URL}`,
      method: 'post',
      header: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      },
      data
    })
  },
  // 获取文件上传秘钥
  getFilePublicCredit() {
    return request({
      url: '/file/getCredit/public',
      method: 'GET',
      fileFlag: true
    })
  },

  // 获取文件上传秘钥 非药企
  getFilePublicCreditOther() {
    return request({
      url: '/file/getCredit/public',
      method: 'GET',
      fileFlag: true
    })
  },
  // 文件转码
  postConvertFile(data = {}) {
    return request({
      url: '/file/imm/convert',
      method: 'POST',
      data,
      fileFlag: true
    })
  }
}
